import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
} from 'recharts';
import { USER_URL } from '../../constant/api';

function SubAdminReportChart({ colors }) {
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [salesData, setSalesData] = useState({});
    const [filteredSalesData, setFilteredSalesData] = useState([]);

    const fetchData = async (url, setState) => {
        try {
            const response = await USER_URL.get(url);
            setState(response.data.Data || []);
            console.log(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        // Fetch sales data for the selected year
        fetchData(`/orders/subadmin/monthly-revenue/?year=${selectedYear}`, (data) => {
            setSalesData((prev) => ({
                ...prev,
                [selectedYear]: data,
            }));
        });
    }, [selectedYear]);

    useEffect(() => {
        if (salesData[selectedYear]) {
            setFilteredSalesData(salesData[selectedYear]);
        }
    }, [salesData, selectedYear]);

    // Calculate total revenue
    const totalRevenue = useMemo(
        () => filteredSalesData.reduce((sum, item) => sum + item.revenue, 0),
        [filteredSalesData]
    );

    // Calculate total sales
    const totalSales = useMemo(
        () => filteredSalesData.reduce((sum, item) => sum + item.sales, 0),
        [filteredSalesData]
    );

    return (
        <div className="border bg-white p-3 rounded-xl shadow-md">
            <div className="flex justify-between items-center mb-4">
                <div>
                    <h2 className="text-3xl font-bold text-gray-900">
                        ₹{totalRevenue.toLocaleString()}
                    </h2>
                    <p className="text-sm text-orange-500 font-semibold">
                        Total Revenue
                    </p>
                </div>
                <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                    className="px-3 py-1 bg-gray-100 rounded-lg border border-gray-300 text-gray-600"
                >
                    {[2022, 2023, 2024, 2025].map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
            </div>
            <ResponsiveContainer width="100%" height={250}>
                <LineChart
                    data={filteredSalesData}
                    margin={{ top: 10, right: 30, left: 10, bottom: 10 }}
                >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis
                        dataKey="month"
                        tickFormatter={(month) => month.slice(0, 3)}
                        tick={{ fontSize: 12 }}
                        interval={0}
                    />
                    <YAxis
                        tickFormatter={(value) => `₹${value.toLocaleString()}`}
                        domain={[0, 'auto']}
                    />
                    <Tooltip formatter={(value) => `₹${value.toLocaleString()}`} />
                    <Line
                        type="monotone"
                        dataKey="revenue"
                        stroke="#00c853"
                        strokeWidth={3}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default SubAdminReportChart;
